import ErrorHandler from "../error-handlers/axios/defaultErrorHandler";

/**
 * Fetches performance data for a specific agent
 * 
 * @param {Object} axiosInstance - Axios instance with authentication
 * @param {string} agentId - The ID of the agent to fetch performance data for
 * @param {Object} options - Request options
 * @param {Object} options.params - Query parameters
 * @param {string} options.params.period - Time period ('daily', 'weekly', 'monthly')
 * @param {string} options.params.startDate - Start date in ISO format
 * @param {string} options.params.endDate - End date in ISO format
 * @returns {Promise<Object>} - Agent performance data
 */
export const getAgentPerformance = async (axiosInstance, agentId, options = {}) => {
  try {
    const res = await axiosInstance.get(`/agent-performance/total-score/${agentId}`, options);
    return res?.data;
  } catch (error) {
    ErrorHandler.handle(error);
    return null;
  }
};
